import localeData from 'react-intl/locale-data/zh'

const messages = {
  'topBar.typeToSearch': '搜索...',
  'topBar.profileMenu.hello': '你好',
  'topBar.profileMenu.role': '角色',
  'topBar.profileMenu.email': '电子邮件',
  'topBar.profileMenu.phone': '电话',
  'topBar.profileMenu.manageMembership': '管理会员资格',
  'topBar.profileMenu.editProfile': '编辑个人资料',
  'topBar.profileMenu.changePassword': '更改密码',
  'topBar.profileMenu.logout': '登出',
  'member.profile.emailAddressTitle': '电子邮件地址',
  'member.profile.emailAddress': '输入电邮地址',
  'member.profile.validEmail': '输入无效电子邮件',
  'member.profile.enterEmail': '请输入电子邮件',
  'member.profile.saveButton': '保存',
}

export default {
  locale: 'zh-CH',
  antdData: null,
  localeData,
  messages,
}
